import {
  api_key,
  root_endpoint,
  sampleId,
  sampleName,
  getDb,
  pathEndpoints,
  getGenreList,
} from "./apiSetUp.js";

const movieGenreList = await getGenreList("getMovieGenreList");
const tvGenreList = await getGenreList("getTVGenreList");

function formatDate(year, option) {
  const month = option === "year_from" ? "01" : "12";
  const day = option === "year_from" ? "01" : "31";
  return `${year}-${month}-${day}`;
}

const sample_list = {
  type: 0,
  genres: ["romance", "drama"],
  keywords: ["drama"],
  runtime_from: 0,
  runtime_to: 180,
  region: ["FR", "GB"],
  year_from: 2018,
  year_to: 2020,
  page: 2,
};

const sample_list2 = {
  genres: ["romance", "drama"],
  keywords: ["drama"],
  runtime_from: 0,
  runtime_to: 180,
  region: ["GB"],
  year_from: 2018,
  year_to: 2020,
  page: 2,
};

export async function search_keywords(keyword) {
  const endpoints =
    root_endpoint + pathEndpoints["searchKeywords"] + `?query=${keyword}`;
  const data = await getDb(endpoints);
  return data;
}

async function test_search_keywords(keyword) {
  const test_data = await search_keywords(keyword);
  console.log(test_data);
  //Test below
  const listKw = test_data.results;
  for (let kw in listKw) {
    console.log(listKw[kw].name);
  }
}

//test_search_keywords("drama");

export async function filter_movie(
  list_of_query,
) {
    let type_of_discover =
      list_of_query["type"] == 0 ? "discoverMovie" : "discoverTV"; ;

  const queryParams = {
    genres: "&with_genres=",
    keywords: "&with_keywords=",
    runtime_from: "&with_runtime.gte=",
    runtime_to: "&with_runtime.lte=",
    region: "&with_origin_country=",
    year_from: "&release_date.gte=",
    year_to: "&release_date.lte=",
    language: "&language=",
    page: "&page=",
    sort: "&sort_by=",
  };

  let additional_endpoints = "";
  //Handle other query except for Region
  for (let query in list_of_query) {
    let queryDetails = list_of_query[query];
    if ((query != "region") & (query != "type") & Array.isArray(queryDetails)) {
      switch (queryDetails.length) {
        case 0:
          additional_endpoints = additional_endpoints;
          break;
        case 1:
          additional_endpoints =
            additional_endpoints + queryParams[query] + queryDetails[0];
          break;
        default:
          additional_endpoints =
            additional_endpoints + queryParams[query] + queryDetails.join(",");
          break;
      }
    } else if (
      (query != "region") &
      (query != "type") &
      !Array.isArray(queryDetails)
    ) {
      additional_endpoints =
        additional_endpoints + queryParams[query] + queryDetails;
    }
  }

  let regionList = list_of_query["region"];

  if (regionList.length == 0) {
    additional_endpoints = additional_endpoints.replace(
      additional_endpoints[0],
      "?"
    );
    let endpoints =
      root_endpoint + pathEndpoints[type_of_discover] + additional_endpoints;
    let data = await getDb(endpoints);
    console.log(endpoints);
    console.log("FILTER w/oREGION RESULT: ", data);

    return data;
  } else {
    let final_data = {
      results: [],
      total_pages: 0,
      total_results: 0,
    };
    
    let regionParams = regionList.join("|");
      let endpoints =
        root_endpoint +
        pathEndpoints[type_of_discover] +
        (additional_endpoints + queryParams["region"] + regionParams).replace(
          additional_endpoints[0],
          "?"
        );
      let data = await getDb(endpoints);
      console.log(endpoints);

      final_data.results = [...final_data.results, ...data.results];
      final_data.total_results += data.total_results;
      final_data.total_pages += data.total_pages;
    
    console.log("FILTER wREGION RESULT: ", final_data);
    return final_data;
  }

  /*
    for (let query in list_of_query){
        if (Array.isArray(list_of_query[query])){
            const additional_query = queryParams[query] + list_of_query[query].join(",");
            additional_endpoints += additional_endpoints === "?" ? additional_query.replace("&","") : additional_query;
        }else if (query.includes("year")) {
            const additional_query = queryParams[query] + formatDate(list_of_query[query], query);
            additional_endpoints += additional_endpoints === "?" ? additional_query.replace("&","") : additional_query;
        }else{
            const additional_query = queryParams[query] + list_of_query[query];
            additional_endpoints += additional_endpoints === "?" ? additional_query.replace("&","") : additional_query;
        }
        
    }

  const endpoints =
    root_endpoint + pathEndpoints[type_of_discover] + additional_endpoints;
  console.log(endpoints);
  const data = await getDb(endpoints);
  return data;*/
}

async function test_filter_movie(list_of_query, type_of_discover) {
  const test_data = await filter_movie(list_of_query, type_of_discover);
  console.log(test_data);
}

//test_filter_movie(sample_list, "discoverMovie");
